/**
 * Account type definitions for user accounts
 */

import type { PlanType } from './pricing';

export type AccountType = 'personal' | 'business';

export interface PersonalAccountMetadata {
  account_type: 'personal';
  first_name: string;
  last_name: string;
  date_of_birth: string;
  assessor_type: string;
  assessor_id: string;
  postcode: string;
  // Subscription plan
  subscription_plan?: PlanType;
}

export interface BusinessAccountMetadata {
  account_type: 'business';
  first_name: string;
  last_name: string;
  date_of_birth: string;
  assessor_type: string;
  assessor_id: string;
  postcode: string;
  // Business-specific fields
  company_name: string;
  company_registration: string;
  vat_number?: string;
  // Subscription plan
  subscription_plan?: PlanType;
}

export type UserAccountMetadata = PersonalAccountMetadata | BusinessAccountMetadata;

export interface AccountTypeOption {
  value: AccountType;
  label: string;
  description: string;
  icon: string;
}

export const ACCOUNT_TYPE_OPTIONS: AccountTypeOption[] = [
  {
    value: 'personal',
    label: 'Personal Account',
    description: 'For individual assessors and freelancers',
    icon: '👤'
  },
  {
    value: 'business',
    label: 'Business Account',
    description: 'For companies and organizations',
    icon: '🏢'
  }
];
